// extracted by mini-css-extract-plugin
module.exports = {"disabled":"DisabledOpacity_disabled__1Ryxq","stripes":"DisabledOpacity_stripes__15yyE"};